import React, { useState, useEffect } from 'react';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner';

import {
  getInitialValues,
  getRegisterSchema,
} from 'web/components/utils/claimRaiseModalUtils';

import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import {
  claimDispute
} from 'redux/actions/myOrders';
import { claimRequest, claimRequestBOL } from 'redux/actions/myClaims';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import Step1 from './Step1';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components'
import styles from './claimRaiseModal.module.scss';

import { Container, Body, RequestDate, RecurrencePattern, Heading, BoxWrapper, ModalContainer, RangeofRecurrence, PatternWrapper, RadioData, RadioWrapper } from './claimRaiseModalStyled'
export default ({ isOpen, toggle, title, content, link, onClickHander, claimRaiseId }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const [step, setStep] = useState(0);

  const [conditionalState, setConditionalState] = useState('QUALITY');
  const [filesArr, setFilesArr] = useState();

  const [response, setResponse] = useState();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);

  const token = localStorage.getItem('token');

  useEffect(() => {
    callDisputeApi(claimRaiseId)
  }, []);
  const callDisputeApi = async (id) => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let data = {
        orderId: id,
      }
      let response = await dispatch(claimDispute(data, token));
      if (response.status === 'SUCCESS') {
        setResponse(response.payload)
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }


  const submitHandler = async (props, setFieldValue) => {
    let issueArr = []
    if (props.values.typeOfIssue0 === true) issueArr.push('EXPOSED_NAILS')
    if (props.values.typeOfIssue1 === true) issueArr.push('BROKEN_BOARD')
    if (props.values.typeOfIssue2 === true) issueArr.push('MISSING_BOARDS')
    if (props.values.typeOfIssue3 === true) issueArr.push('OTHER')
    let obj;
    if (props.values.claimIssue === "QUALITY") {
      obj = {
        imagefiles: filesArr,
        orderId: claimRaiseId,
        issueType: props.values.claimIssue,
        typeOfIssues: issueArr,
        totalPalletQuality: props.values.totalNumberQuality,
        comments: props.values.comments,
      }
    } else if (props.values.claimIssue === "QUANTITY") {
      obj = {
        imagefiles: [],
        orderId: claimRaiseId,
        issueType: props.values.claimIssue,
        typeOfIssues: '',
        totalPalletQuantity: props.values.totalNumberQuantity,
        comments: props.values.comments,
      }
    } else if (props.values.claimIssue === "BOTH") {
      obj = {
        imagefiles: filesArr,
        orderId: claimRaiseId,
        issueType: props.values.claimIssue,
        typeOfIssues: issueArr,
        totalPalletQuality: props.values.totalNumberQuality,
        totalPalletQuantity: props.values.totalNumberQuantity,
        comments: props.values.comments,
      }
    } else {
      obj = {
        orderId: claimRaiseId,
        issueType: props.values.claimIssue,
        comments: props.values.comments,
      }
    }
    let formData = new FormData();
    const propsData = obj;
    for (let prop in propsData) {
      if (prop === "imagefiles" && propsData[prop] && propsData[prop].length !== 0) {
        for (let i = 0; i < propsData[prop].length; i++) {
          formData.append(prop, propsData[prop][i])
        }
      }
      else {
        formData.append(prop, propsData[prop])
      }
    }

    if (props.values.totalNumberQuality.includes('.') || props.values.totalNumberQuantity.includes('.')) {
      setModalContent('The total quantity/total quality issue count should not be a decimal value.');
      setModalLink('');
      toggleModal();
      return
    }

    let response
    if (props.values.claimIssue === 'BOL') {
      response = await dispatch(claimRequestBOL(formData, token));
    } else {
      response = await dispatch(claimRequest(formData, token));
    }

    if (response.status === 'SUCCESS') {
      setModalContent(response.message);
      setModalLink('/resolution-center');
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink('');
        toggleModal();
      }
    }
  }
  return (<>
    {response && <ModalContainer>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        fullscreen='fullscreen'
        className={styles.recurranceModal}
      >
        <div className=''>
          <div className={styles.header}>
            <Button handleClick={() => {
              setStep(0)
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            <Formik
              initialValues={getInitialValues(response)}
              validationSchema={getRegisterSchema(conditionalState)}
              onSubmit={(values) => {
              }}>
              {(props) => {
                const {
                  setFieldValue,
                } = props;
                return (
                  <>
                    <Form>
                      <Container>
                        <Body>
                          {loaderVisible && <Spinner />}
                          {step === 0 && <Step1 response={response} props={props} setFieldValue={setFieldValue} imageLoadCallBack={(imageArr) => {
                            setFilesArr(imageArr)
                          }}
                            callBackFun={(val) => {
                              getRegisterSchema(val)
                              setConditionalState(val)
                            }} />}

                          <ActionBtn>
                            <Button
                              type='app-green-button'
                              disabled={(((props.values.claimIssue === 'QUALITY' || props.values.claimIssue === 'BOTH') ? (filesArr && filesArr.length > 0) : true) && props.values.comments !== '' &&
                                (props.values.claimIssue === 'QUALITY' ? props.values.totalNumberQuality !== '' : props.values.claimIssue === 'QUANTITY' ? props.values.totalNumberQuantity !== '' : props.values.claimIssue === 'BOTH' ? (props.values.totalNumberQuality !== '' && props.values.totalNumberQuantity !== '') : true) &&
                                ((props.values.claimIssue === 'QUALITY' || props.values.claimIssue === 'BOTH') ? (props.values.typeOfIssue0 || props.values.typeOfIssue1 || props.values.typeOfIssue2 || props.values.typeOfIssue3) : true))
                                ? false : true}
                              handleClick={async () => {
                                submitHandler(props, setFieldValue)
                              }}>
                              Submit
                            </Button>
                          </ActionBtn>
                        </Body>
                      </Container>
                    </Form>
                  </>
                )
              }}
            </Formik>

          </ModalBody>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
          />
        </div>
      </Modal>
    </ModalContainer>
    }
  </>
  );
};

const DailyWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    > div {
      display: flex;
    align-items: center;
        gap: 10px;

    .app-input-text {
      margin: 0;
      input {
        max-width: 54px;
    text-align: center;
      }
    }
    }
`

const EndAfter = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
 .app-input-text {
      max-width: 124px;
    }
    > p {
      margin-bottom: 20px;
    }
`

const EndRadioWrapper = styled.div`
    display: flex;
    width: 100px;
    flex-direction: column;
    align-items: flex-start;
    
    > div {
        margin: 9px 0;
    }
`
const StartWrapper = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
    padding-left: 0;
    margin-bottom: 15px;
 > div {
   :first-child {
    width: 85px;
    text-align: left;
   }
 }
`

const ActionBtn = styled.div`
 display: flex;
     margin: 15px 0;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    > button {
      height: 38px;
    width: 90px;
    }

`

const WeeklyDays = styled.div`    
    display: flex;
    flex-wrap: wrap;
    grid-column-gap: 15px;
    margin: 15px 0;
      > div {
        min-width: 100px;
        text-align: left;
      }
      @media (max-width:495px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    `

const TheDaySection = styled.div`
  display: flex;
  > div {
    flex:1;
    :first-child {
      max-width: 100px;
      text-align: left;
      > div {
            margin-bottom: 15px;
      }
    }
  }
`
const NoDay = styled.div`
  display: flex;
  gap: 15px;
      margin-bottom: 15px;
      p {
        margin:0;
      }
  .app-input-text {
    margin: 0;
        flex: 1;
    max-width: 54px;
    input {
      text-align: center;
    }
  }

`

const TheDay = styled.div`
  display: flex;
  gap: 10px;
  p {
    margin:0;
  }
  > div {
    flex:1;
    :first-child {
      max-width: 120px;
    }
    :nth-child(2) {
      max-width: 100px;
    }
  }

`